import styled from "styled-components";

export const StyledLoadingIndemnitor = styled.div`
  background: white;
  padding: 0 115px;
  background: white;
  padding-top: 40px;
  white-space: nowrap;

  @media only screen and (max-width: 768px) {
    padding: 0 20px;
    padding-top: 40px;
  }
`;

export const StyledAddIndemnitor = styled.div`
  position: absolute;
  bottom: 80px;
  width: 100%;
  left: 50%;
  text-align: center;
  transform: translate(-50%, 50%);
  font-family: "Inter", sans-serif;
  font-weight: bold;
  font-size: 18px;
  line-height: 126.4%;
`;

export const StyledAddIndemnitorButton = styled.button`
  color: #f80d0d;
  text-decoration: underline;
  text-underline-offset: 2px;
  font-weight: bold;
`;

export const StyledSubmitContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
`;
export const StyledIndemnitorDivider = styled.div`
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  &:not(:first-child) {
    border-top: 2px solid var(--primary);
    padding-top: 40px;
  }
`;

export const StyledRemoveIndemnitor = styled.button`
  font-family: "Inter", sans-serif;
  font-weight: bold;
  font-size: 18px;
  display: flex;
  gap: 20px;
  color: #f80d0d;
  align-items: center;

  @media only screen and (max-width: 400px) {
    font-size: 14px;
  }
`;

export const StyledIndemnitorLabel = styled.span`
  font-weight: bold;
  line-height: 19px;
`;

export const StyledSubmitInfo = styled.div`
  margin-top: 40px;
  font-family: "Inter", sans-serif;
`;

export const StyledIndemnitorControl = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  align-items: center;
  margin-bottom: 40px;
`;

export const StyledIndemnitorInfo = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
`;
